/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { get, put } from '@/services/api/client';
import { ApiResponse } from '@/services/api/types';
import { OrganizationProfile, UpdateOrgProfileRequest } from '@/types/superadmin.types';

const BASE_URL = '/organizations/my-profile';

export const orgProfileService = {
  async getProfile(): Promise<OrganizationProfile> {
    const response = await get<ApiResponse<OrganizationProfile>>(BASE_URL);
    return response.data;
  },

  async updateProfile(data: UpdateOrgProfileRequest): Promise<OrganizationProfile> {
    const response = await put<ApiResponse<OrganizationProfile>>(BASE_URL, data);
    return response.data;
  },
};
